
(function () {
  if (window.__salepifyYmalVariantSwatchesLoaded) return;
  window.__salepifyYmalVariantSwatchesLoaded = true;

  var PALETTE = {
    'charlotte 2': 'rgb(217, 209, 180)',
    'charlotte 11': 'rgb(205, 219, 230)',
    'charlotte 31': 'rgb(241, 214, 227)',
    'charlotte 32': 'rgb(203, 216, 166)',
    'semimagia 5': 'rgb(196, 158, 151)',
    'semimagia 7': 'rgb(91, 45, 53)',
    'semimagia 15': 'rgb(102, 115, 165)',
    'semimagia 26': 'rgb(169, 171, 173)'
  };

  var A = '.salepify-ymal-item.salepify-custom-picker-active';
  var F = '.salepify-ymal-custom-footer';
  var CSS = `
${A}{display:flex!important;flex-direction:column!important;align-items:stretch!important;justify-content:flex-start!important;gap:12px!important;width:100%!important;box-sizing:border-box!important}
${A} .salepify-ymal-product{display:flex!important;flex-direction:row!important;align-items:center!important;gap:14px!important;width:100%!important}
${A} .salepify-ymal-product__image{width:68px!important;height:68px!important;min-width:68px!important;min-height:68px!important;flex-shrink:0!important;border-radius:8px!important;overflow:hidden!important}
${A} .salepify-ymal-product__image img{width:100%!important;height:100%!important;object-fit:cover!important}
${A} .salepify-ymal-product__info{display:flex!important;flex-direction:column!important;gap:4px!important;flex:1!important;min-width:0!important}
${A} .salepify-ymal-product-title{font-size:15px!important;font-weight:600!important;color:#121212!important;line-height:1.3!important}
${A} .salepify-ymal-variant-selector{display:none!important}
.salepify-ymal-custom-picker{display:flex!important;flex-direction:column!important;gap:12px!important;margin:2px 0 4px 0!important;width:100%!important;box-sizing:border-box!important}
.salepify-ymal-custom-group{display:flex!important;flex-direction:column!important;gap:6px!important;width:100%!important}
.salepify-ymal-custom-label-row{display:flex!important;flex-direction:row!important;justify-content:space-between!important;align-items:baseline!important;line-height:1.3!important;width:100%!important}
.salepify-ymal-custom-title-label{font-size:13px!important;font-weight:500!important;color:#121212!important;letter-spacing:0.02em!important}
.salepify-ymal-custom-color-selected{font-size:12px!important;color:#666!important}
.salepify-ymal-custom-color-selected strong{color:#121212!important;font-weight:600!important}
.salepify-ymal-custom-swatches{display:flex!important;flex-wrap:wrap!important;align-items:center!important;gap:10px!important;padding:2px 0!important;width:100%!important}
.salepify-ymal-swatch-btn{position:relative!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;width:30px!important;height:30px!important;min-width:30px!important;min-height:30px!important;padding:0!important;margin:0!important;background:transparent!important;border:none!important;border-radius:50%!important;cursor:pointer!important;outline:none!important;transition:transform 0.15s ease,box-shadow 0.15s ease!important}
.salepify-ymal-swatch-btn:hover{transform:scale(1.12)!important}
.salepify-ymal-swatch-circle{display:block!important;width:25px!important;height:25px!important;border-radius:50%!important;box-shadow:inset 0 0 0 1px rgba(0,0,0,0.12)!important;transition:all 0.2s ease!important}
.salepify-ymal-swatch-btn.is-active{box-shadow:0 0 0 1.5px #fff,0 0 0 3px #121212!important}
.salepify-ymal-swatch-btn.is-active .salepify-ymal-swatch-circle{box-shadow:none!important}
.salepify-ymal-custom-pills{display:flex!important;flex-wrap:wrap!important;align-items:stretch!important;gap:8px!important;width:100%!important}
.salepify-ymal-pill-btn{flex:1 1 calc(33.333% - 8px)!important;min-width:max-content!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;padding:8px 12px!important;font-size:11px!important;font-weight:500!important;line-height:1.2!important;color:#121212!important;background-color:#fff!important;border:1px solid rgba(0,0,0,0.18)!important;border-radius:20px!important;cursor:pointer!important;outline:none!important;transition:all 0.2s ease!important;white-space:nowrap!important;text-align:center!important;box-sizing:border-box!important}
.salepify-ymal-pill-btn:hover{border-color:#121212!important}
.salepify-ymal-pill-btn.is-active{color:#fff!important;background-color:#121212!important;border-color:#121212!important}
${F}{display:flex!important;flex-direction:row!important;justify-content:space-between!important;align-items:center!important;width:100%!important;padding-top:10px!important;margin-top:4px!important;border-top:1px solid rgba(0,0,0,0.08)!important;box-sizing:border-box!important}
${F} .salepify-ymal-product-price{display:flex!important;flex-direction:row!important;align-items:center!important;gap:8px!important;margin:0!important}
${F} .salepify-ymal-product-price__final{font-size:16px!important;font-weight:700!important;color:#0d0d0d!important}
${F} .salepify-ymal-product-price__regular{font-size:13px!important;color:#6c6b64!important;text-decoration:line-through!important}
${F} .salepify-ymal-add-btn{display:inline-flex!important;align-items:center!important;justify-content:center!important;gap:6px!important;padding:10px 22px!important;font-size:12px!important;font-weight:700!important;letter-spacing:0.08em!important;color:#fff!important;background-color:#0d0d0d!important;border:1px solid #0d0d0d!important;border-radius:8px!important;cursor:pointer!important;white-space:nowrap!important;transition:all 0.2s ease!important;margin:0!important}
${F} .salepify-ymal-add-btn:hover{opacity:0.9!important}`;

  function resolveSwatchColor(colorName) {
    if (!colorName) return '#e0e0e0';
    var name = colorName.toLowerCase().trim();
    try {
      var labels = document.querySelectorAll('.product-form__input--swatch label, [data-swatch-label], .swatch-input__label, .swatch-anchor');
      for (var i = 0; i < labels.length; i++) {
        var title = (labels[i].getAttribute('title') || labels[i].textContent || '').toLowerCase().trim();
        if (title.indexOf(name) === -1 && name.indexOf(title) === -1) continue;
        var sw = labels[i].querySelector('.swatch, [style*="--swatch-background"], [style*="background"]');
        var bg = sw && (sw.style.getPropertyValue('--swatch-background') || sw.style.backgroundColor || sw.style.background);
        if (bg) return bg;
      }
    } catch (e) {}
    if (PALETTE[name]) return PALETTE[name];
    for (var key in PALETTE) {
      if (name.indexOf(key) !== -1 || key.indexOf(name) !== -1) return PALETTE[key];
    }
    return '#d1d5db';
  }

  // "SEMIMAGIA 15 / PEQUEÑO: 63 X 63 X 9 CM" -> { color: "SEMIMAGIA 15", size: "PEQUEÑO: 63 X 63 X 9 CM" }
  function parseVariantTitle(title, variant) {
    if (variant && (variant.option1 || variant.option2)) {
      return { color: (variant.option1 || '').trim(), size: (variant.option2 || '').trim() };
    }
    var parts = (title || '').split('/');
    return { color: (parts[0] || '').trim(), size: (parts[1] || '').trim() };
  }

  // ALL CAPS -> Title Case
  function formatDisplayName(str) {
    if (str && str === str.toUpperCase() && /[A-Z]/.test(str)) {
      return str.toLowerCase().replace(/\b\w/g, function (l) { return l.toUpperCase(); });
    }
    return str || '';
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function updateActiveStates(picker, colorNorm, sizeNorm, colorName) {
    var label = picker.querySelector('.salepify-ymal-custom-color-selected strong');
    if (label && colorName) label.textContent = formatDisplayName(colorName);
    picker.querySelectorAll('.salepify-ymal-swatch-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-color-norm') === colorNorm);
    });
    picker.querySelectorAll('.salepify-ymal-pill-btn').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-size-norm') === sizeNorm);
    });
  }

  function processItem(item) {
    try {
      var select = item.querySelector('.salepify-ymal-variant-selector select');
      if (!select || select.options.length <= 1) return;

      var widget = item.closest('salepify-ymal');
      var variantMap = widget && widget.variantIdMapData;
      var colors = new Map(); // norm -> original name, keeps option order
      var sizes = new Map();
      var variants = Array.prototype.map.call(select.options, function (opt) {
        var id = Number(opt.value);
        var p = parseVariantTitle(opt.textContent, variantMap && (variantMap.get(id) || variantMap.get(String(id))));
        var colorNorm = p.color.toLowerCase();
        var sizeNorm = p.size.toLowerCase();
        if (colorNorm && !colors.has(colorNorm)) colors.set(colorNorm, p.color);
        if (sizeNorm && !sizes.has(sizeNorm)) sizes.set(sizeNorm, p.size);
        return { id: String(id), colorNorm: colorNorm, sizeNorm: sizeNorm };
      });
      if (!colors.size && !sizes.size) return;

      item.classList.add('salepify-custom-picker-active');

      function current() {
        return variants.find(function (v) { return v.id === String(select.value); }) || variants[0];
      }

      var picker = item.querySelector('.salepify-ymal-custom-picker');
      if (picker) {
        var cur = current();
        updateActiveStates(picker, cur.colorNorm, cur.sizeNorm, colors.get(cur.colorNorm));
        return;
      }

      // exact color+size combo, else the first variant that has the clicked option
      function choose(colorNorm, sizeNorm, key, value) {
        var v = variants.find(function (x) { return x.colorNorm === colorNorm && x.sizeNorm === sizeNorm; }) ||
          variants.find(function (x) { return x[key] === value; });
        if (!v) return;
        updateActiveStates(picker, v.colorNorm, v.sizeNorm, colors.get(v.colorNorm));
        if (select.value !== v.id) {
          select.value = v.id;
          select.dispatchEvent(new window.Event('change', { bubbles: true }));
        }
      }

      function addGroup(type, title, options, makeButton) {
        var group = picker.appendChild(el('div', 'salepify-ymal-custom-group salepify-ymal-custom-group--' + type));
        var row = group.appendChild(el('div', 'salepify-ymal-custom-label-row'));
        row.appendChild(el('span', 'salepify-ymal-custom-title-label', title));
        if (type === 'color') row.appendChild(el('span', 'salepify-ymal-custom-color-selected', 'Color: ')).appendChild(el('strong', ''));
        var list = group.appendChild(el('div', type === 'color' ? 'salepify-ymal-custom-swatches' : 'salepify-ymal-custom-pills'));
        options.forEach(function (original, norm) {
          var btn = list.appendChild(makeButton(original, norm));
          btn.type = 'button';
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            var cur = current();
            if (type === 'color') choose(norm, cur.sizeNorm, 'colorNorm', norm);
            else choose(cur.colorNorm, norm, 'sizeNorm', norm);
          });
        });
      }

      picker = el('div', 'salepify-ymal-custom-picker');
      if (colors.size) {
        addGroup('color', 'Seleccionar Color', colors, function (original, norm) {
          var btn = el('button', 'salepify-ymal-swatch-btn');
          btn.setAttribute('data-color-norm', norm);
          btn.setAttribute('title', formatDisplayName(original));
          btn.setAttribute('aria-label', original);
          btn.appendChild(el('span', 'salepify-ymal-swatch-circle')).style.background = resolveSwatchColor(original);
          return btn;
        });
      }
      if (sizes.size) {
        addGroup('size', 'Tamaño', sizes, function (original, norm) {
          var btn = el('button', 'salepify-ymal-pill-btn', formatDisplayName(original));
          btn.setAttribute('data-size-norm', norm);
          return btn;
        });
      }
      var initial = current();
      updateActiveStates(picker, initial.colorNorm, initial.sizeNorm, colors.get(initial.colorNorm));

      var productEl = item.querySelector('.salepify-ymal-product');
      if (productEl) productEl.insertAdjacentElement('afterend', picker);
      else item.appendChild(picker);

      // footer row: price left, add button right
      if (!item.querySelector(F)) {
        var footer = el('div', 'salepify-ymal-custom-footer');
        var price = item.querySelector('.salepify-ymal-product-price');
        var addBtn = item.querySelector('.salepify-ymal-add-btn');
        if (price) footer.appendChild(price);
        if (addBtn) footer.appendChild(addBtn);
        picker.insertAdjacentElement('afterend', footer);
      }
    } catch (err) {
      console.warn('[Salepify YMAL Variant Swatches] processItem error:', err);
    }
  }

  function processAllItems() {
    document.querySelectorAll('.salepify-ymal-item').forEach(processItem);
  }

  function init() {
    try {
      if (!document.getElementById('salepify-ymal-variant-swatches-style')) {
        document.head.insertAdjacentHTML('beforeend', '<style id="salepify-ymal-variant-swatches-style">' + CSS + '</style>');
      }
      processAllItems();

      // YMAL re-renders on load / slide change: re-apply at most once per frame
      var scheduled = false;
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          processAllItems();
        });
      }).observe(document.body, { childList: true, subtree: true });

      document.addEventListener('change', function (event) {
        var select = event.target.closest && event.target.closest('.salepify-ymal-variant-selector select');
        var item = select && select.closest('.salepify-ymal-item');
        if (item) processItem(item);
      }, true);
    } catch (e) {
      console.warn('[Salepify YMAL Variant Swatches] init error:', e);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // used by salepify-ymal-variant-swatches.test.js
  window.SalepifyYmalVariantSwatches = {
    resolveSwatchColor: resolveSwatchColor,
    parseVariantTitle: parseVariantTitle,
    formatDisplayName: formatDisplayName,
    processItem: processItem,
    processAllItems: processAllItems
  };
})();
